import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditor from './Forms/RichTextEditor';
import { ActionButton } from './Forms/ActionButton';
import { useCreatePolicyData, useGetAppPolicy, useUpdatePolicy } from '../queries/appInfo';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';

const PrivacyPolicy = () => {

    const { data: policy, isPending: isPolicyPending } = useGetAppPolicy();
    const { mutateAsync: updatePolicy, isPending: isUpdating } = useUpdatePolicy();
    const { mutateAsync: createPolicy } = useCreatePolicyData();

    const [show, setShow] = React.useState(false);

    const {
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm({
        defaultValues: {
            privacyPolicy: '',
        }
    });

    // Watch form values for rich text editors
    const privacyPolicy = watch('privacyPolicy');

    // Set form values when data is loaded
    useEffect(() => {
        if (policy) {
            setValue('privacyPolicy', policy.content || '');
        }
    }, [policy, setValue]);

    const handleUpdateAppInfo = async (formData) => {
        try {
            if (policy?._id) {
                await updatePolicy(
                    {
                        id: policy?._id,
                        content: privacyPolicy,
                    },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('Policy Updated!');
                        },
                        onError: (err) => {
                            toast.error('Error updating policy!');
                        }
                    }
                );
            } else {
                await createPolicy(
                    { content: privacyPolicy },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('Policy Created!');
                        },
                        onError: (err) => {
                            toast.error('Error creating policy!');
                        }
                    }
                );
            }
        } catch (err) {
            toast.error("Failed to update app information");
        }
    };

    if (isPolicyPending) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <>
            <div className='bg-white shadow-md rounded-lg p-7'>
                <form onSubmit={handleSubmit(handleUpdateAppInfo)} className="space-y-6">
                    {/* Terms and Conditions Section */}
                    {/* <div className="bg-gray-50 rounded-lg p-5">
                        <h3 className="text-xl text-primary font-bold mb-4">Terms and Conditions</h3>
                        <RichTextEditor
                            label="Terms and Conditions Content"
                            value={termsAndConditions}
                            placeholder="Enter the terms and conditions for your app..."
                            onChange={(value) => setValue('termsAndConditions', value)}
                            required={true}
                        />
                        {errors.termsAndConditions && (
                            <p className="text-red text-sm mt-2">
                                {errors.termsAndConditions.message || "Terms and Conditions are required"}
                            </p>
                        )}
                    </div> */}

                    {/* Privacy Policy Section */}
                    <div className="bg-gray-50 rounded-lg">
                        <h3 className="text-xl text-primary font-bold mb-4 cursor-pointer flex items-center" onClick={() => setShow(!show)}>{show ? <FaAngleDown className='text-secondary' /> : <FaAngleRight className='text-secondary' />} Privacy Policy</h3>
                        {
                            show && (
                                <>
                                    <RichTextEditor
                                        label="Privacy Policy Content"
                                        value={privacyPolicy}
                                        placeholder="Enter the privacy policy for your app..."
                                        onChange={(value) => setValue('privacyPolicy', value)}
                                        required={true}
                                    />
                                    {errors.privacyPolicy && (
                                        <p className="text-red text-sm mt-2">
                                            {errors.privacyPolicy.message || "Privacy Policy is required"}
                                        </p>
                                    )}
                                    {/* Submit Button */}
                                    <div className='flex justify-end mt-6'>
                                        <ActionButton
                                            text={isUpdating ? 'Updating...' : 'Update Policy'}
                                            variant={'submit'}
                                            disabled={isUpdating}
                                        />
                                    </div>
                                </>
                            )
                        }
                    </div>

                    {/* App Info Section */}
                    {/* <div className="bg-gray-50 rounded-lg p-5">
                        <h3 className="text-xl text-primary font-bold mb-4">App Information</h3>
                        <RichTextEditor
                            label="General App Information"
                            value={appInfo}
                            placeholder="Enter general information about your app..."
                            onChange={(value) => setValue('appInfo', value)}
                            required={true}
                        />
                        {errors.appInfo && (
                            <p className="text-red text-sm mt-2">
                                {errors.appInfo.message || "App Information is required"}
                            </p>
                        )}
                    </div> */}
                </form>
            </div>

            <ToastContainer
                position="top-right"
                autoHideDuration={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

export default PrivacyPolicy;